<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-row :gutter="35" class="mgb20">
                    <el-col :span="6">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-1">
                                <i class="el-icon-s-custom grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num">{{count.bingli}}</div>
                                    <div>已登记病例</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-2">
                                <i class="el-icon-circle-plus grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num">{{count.shencun}}</div>
                                    <div>生存</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-3">
                                <i class="el-icon-success grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num">{{count.huanjie}}</div>
                                    <div>缓解</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content grid-con-4">
                                <i class="el-icon-error grid-con-icon"></i>
                                <div class="grid-cont-right">
                                    <div class="grid-num">{{count.siwang}}</div>
                                    <div>死亡</div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
<!--                    <el-col :span="5">-->
<!--                        <el-card shadow="hover" :body-style="{padding: '0px'}">-->
<!--                            <div class="grid-content grid-con-5" @click="handleSuifang">-->
<!--                                <i class="el-icon-phone grid-con-icon"></i>-->
<!--                                <div class="grid-cont-right">-->
<!--                                    <div class="grid-num">{{count.suifang}}</div>-->
<!--                                    <div>随访待更新</div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </el-card>-->
<!--                    </el-col>-->
                </el-row>
            </el-col>
        </el-row>
        <el-row>
            <el-card shadow="hover">
                <div slot="header" class="clearfix">
                    <span>病例共享数据补充</span>
                </div>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content-shart grid-con-3">
                                <div class="grid-cont-right tiaoz">
                                    <div class="grid-num-shart">
                                        补充<span style="color: red;" class="grid-num">{{shareData.death||0}}</span>
                                        <span>例</span>
                                    </div>
                                    <el-button @click="jump('/rms/archives?type=death')" class="grid-num-shart but">死亡信息</el-button>
                                </div>
                            </div>
                        </el-card>
                        <div style="padding: 15px 0;line-height: 25px;font-size: 14px;">
                            <span style="font-weight: bold">死亡时间共享:</span>
                            通过NCC 的肿瘤登记数据库和CDC 的死因数据库合作，获知患者的<span style="color: #409eff;font-weight: bold">死亡时间</span>。
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content-shart grid-con-3">
                                <div class="grid-cont-right tiaoz">
                                    <div class="grid-num-shart">
                                        更新<span style="color: red;" class="grid-num">{{shareData.follow||0}}</span>
                                        <span >例</span>
                                    </div>
                                    <el-button  @click="jump('/rms/archives?type=follow')" class="grid-num-shart but" size="mini">末次随访信息</el-button>
                                </div>
                            </div>
                        </el-card>
                        <div style="padding: 15px 0;line-height: 25px;font-size: 14px;">
                            <span style="font-weight: bold">末次随访时间共享:</span>
                            通过病案首页数据库中全国公立二、三级医院的<span style="color: #409eff;font-weight: bold">最后一次出院时间</span>补充。
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content-shart grid-con-3">
                                <div class="grid-cont-right tiaoz">
                                    <div class="grid-num-shart">
                                        新增<span
                                            style="color: red;" class="grid-num">{{shareData.relapse + shareData.remission||0}}</span>
                                        <span >例</span>
                                    </div>
                                    <el-button class="grid-num-shart but"  @click="jump('/rms/archives?type=relapse')">缓解/复发</el-button>
                                </div>
                            </div>
                        </el-card>
                        <div style="padding: 15px 0;line-height: 25px;font-size: 14px;">
                            <span style="font-weight: bold">缓解和复发时间共享:</span>
                            通过病案首页数据库中<span style="color: #409eff;font-weight: bold">诊断名称和编码</span>补充。
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content-shart grid-con-3">
                                <div class="grid-cont-right tiaoz">
                                    <div class="grid-num-shart">
                                        新增<span style="color: red;" class="grid-num">{{shareData.transplant||0}}</span>
                                        <span>例</span>
                                    </div>
                                    <el-button @click="jump('/rms/archives?type=transplant')" class="grid-num-shart but" plain>移植记录</el-button>
                                </div>
                            </div>
                        </el-card>
                        <div style="padding: 15px 0;line-height: 25px;font-size: 14px;">
                            <span style="font-weight: bold">移植共享:</span>
                            通过病案首页数据库中<span style="color: #409eff;font-weight: bold">手术操作名称和编码</span>补充。
                        </div>
                    </el-col>
                </el-row>
            </el-card>
        </el-row>
        <el-row>
            <el-card>
                <div slot="header" class="clearfix">
                    <span>病例分类数量</span>
                </div>
                <el-row :gutter="10" class="data-sum">
                    <el-col :span="5" v-for="(items,index) in dataSum" :key="index">
                        <el-card shadow="hover" :body-style="{padding: '0px'}">
                            <div class="grid-content-sharts grid-con-3">
                                <div class="grid-cont-right tiaoz">
                                    <div class="grid-num-shart" style="color: #80b0d2">
                                        <span >{{items.value}}</span>
                                        <span >例</span>
                                    </div>
                                    <el-button class="grid-num-shart but"  @click="jump(`/rms/archives?name=存活，已随访`)" v-if="items.name.indexOf('存活')>-1">{{items.name}}</el-button>
                                    <el-button class="grid-num-shart but"  @click="jump(`/rms/archives?name=${items.name}`)" v-else>{{items.name}}</el-button>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-card>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-row :gutter="20">
                    <el-col :span="7">
                        <el-card shadow="hover">
                            <div slot="header" class="clearfix">
                                <span>病例分类数量</span>
                            </div>
                            <shencunzhuangtai :dataPie="dataPie" :colorList="colorList" v-loading="loading"/>
                        </el-card>
                    </el-col>
                    <el-col :span="10">
                        <el-card shadow="hover">
                            <div slot="header" class="clearfix">
                                <span>病例共享数据补充</span>
                            </div>
                            <bingli :shareData="shareData"/>
                        </el-card>
                    </el-col>
                    <el-col :span="7">
                        <el-card shadow="hover">
                            <div slot="header" class="clearfix">
                                <span>生存修正</span>
                            </div>
                            <div style="height:240px">
                                <img :src="require('@/assets/images/shengcun3.png')"
                                          :key="imageKey"
                                          style="height:240px !important;width:100%"/>
                            </div>
                            <div style="height: 55px;line-height: 17px;font-size: 13px;padding-top: 5px;overflow:auto">
                                *登记系统与多个国家级数据库合作开展多源数据融合，大幅提升全国白血病登记病例的生存结局信息完整性。共享数据融合后初发急性白血病患者的生存曲线显示出了显著差异。
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row>
            <el-card shadow="hover">
                <div slot="header" class="clearfix">
                    <span>简介</span>
                </div>
                <el-col :span="24" style="border-bottom: 1px solid #EBEEF5;">
                    <el-row>
                        <el-col :span="20">
                            <el-row>
                                <el-col :span="24">
                                    <span style="line-height: 30px;font-size: 14px;">
                                        &nbsp; &nbsp; &nbsp; 为全面提高我国白血病医疗救治，推动白血病精准医学的发展，国家卫生健康委员会先后启动了中国儿童和成人白血病诊疗登记管理系统。其中成人白血病诊疗登记管理系统覆盖了32个省市自治区直辖市。
                                    </span>
                                </el-col>
                                <el-col :span="24" style="margin-top:4%">
                                    <el-row class="tiaoz">
                                        <el-col :span="8">
                                            <el-button @click="jump('/rms/registration')" plain>开始登录新病例</el-button>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-button @click="jump('/rms/archives')" plain>查看/修改登录信息</el-button>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-button @click="jump('/rms/help')" plain>观看典型案例示范</el-button>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="4" style="text-align: center;">
                            <img src="../../assets/images/A01.png" width="120" v-if="user=='A01'"/>
                            <img src="../../assets/images/A02.jpg" width="120" v-else-if="user=='A02'"/>
                            <img src="../../assets/images/A03.jpg" width="120" v-else-if="user=='A03'"/>
                            <img src="../../assets/images/A04.jpg" width="120" v-else-if="user=='A04'"/>
                            <img src="../../assets/images/A05.jpg" width="120" v-else-if="user=='A05'"/>
                            <img src="../../assets/images/login-qr.png" width="120" v-else/><br>
                            <span style="font-size:13px;">
                                扫描上方二维码<br>加入国家白血病登记交流群
                            </span>
                        </el-col>
                    </el-row>
                </el-col>
            </el-card>
        </el-row>
        <model-data :visible.sync="visible" @close="handelClose" :shareData="shareData" :hospital="hospital"
                    :countCase="count.bingli" :dsfCount="dsfCount"></model-data>
    </div>
</template>

<script>
    import BingLi from './widgets/bingli'
    import ShenCunZhuangTai from './widgets/shencunzhuangtai'
    import modelData from './widgets/modelData'

    export default {
        name: 'dashboard',
        components: {
            bingli: BingLi,
            shencunzhuangtai: ShenCunZhuangTai,
            modelData: modelData,
        },
        data() {
            return {
                user: '',
                count: {
                    bingli: 0,
                    shencun: 0,
                    siwang: 0,
                    suifang: 0,
                    huanjie: 0,
                },
                shareData: {},
                visible: true,
                loading: false,
                hospital: "",
                dsfCount: "",
                imageKey: 1,
                dataPie: [],
                dataSum:[],
                colorList: []
            }
        },
        mounted() {
            // this.$nextTick(() => {
            //     // 告诉父组件准备好接收消息了
            //     window.parent.postMessage({
            //         cmd: '/rms/dashboard'
            //     }, '*')
            // })
            var msg = localStorage.getItem('msg')
            if (msg) {
                this.visible = false
            }
            var username = localStorage.getItem('username')
            this.user = username.substring(0, 3)
            if (username != 'demo') {
                this.getData()
                this.getShareData()
                this.getDataPie()
            } else {
                this.count = {
                    bingli: 528,
                    shencun: 211,
                    siwang: 141,
                    suifang: 31,
                    huanjie: 145,
                }
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.imageKey++; // 每次进入页面时增加imageKey的值
            });
        },
        methods: {
            combineItems() {
                let combinedValue = 0;
                let that = this
                let tags = ['待随访', '死亡(共享数据)', '死亡(自主上报)', "存活(已随访)","失访"]
                let tagsFound = {}; // 用于记录找到的标签

                // 过滤和合并特定项
                const processedItems = this.dataPie.filter(item => {
                    that.colorList.push(item.color); // 假设这是需要的操作
                    if (item.name === "待随访（第一批）" || item.name === "待随访（第二批）" || item.name === "待随访（第一批）*") {
                        combinedValue += item.value;
                        return false; // 不包含当前项
                    }
                    tagsFound[item.name] = true; // 标记找到的标签
                    return true; // 保留当前项
                });

                // 将合并后的项添加到结果数组中
                processedItems.unshift({ name: "待随访", value: combinedValue });
                tagsFound["待随访"] = true; // 标记“待随访”已经被添加

                // 检查并添加缺失的标签
                tags.forEach(tag => {
                    if (!tagsFound[tag]) {
                        processedItems.push({ name: tag, value: 0 }); // 为缺失的标签添加值为0的项
                    }
                });
                this.dataSum = processedItems;
            },
            getDataPie(){
                this.loading = true
                this.$http.get('/case/dashboard/charttwo/').then(res => {
                    if (res.data.code === 1) {
                        this.dataPie = res.data.data;
                        this.combineItems()
                        this.loading = false
                    }
                })
            },
            handleImageLoad() {
                this.imageLoaded = true;
                console.log(111)
            },
            handelClose() {
                this.visible = false;
                localStorage.setItem('msg', "flase")
            },
            getShareData() {
                this.$http.get("/case/dashboard/share/").then(resp => {
                    this.shareData = resp.data.data;
                    this.hospital = resp.data.hospital;
                    this.dsfCount = resp.data.count;
                });
            },
            getData() {
                this.$http.get("/case/dashboard/").then(resp => {
                    this.count = resp.data.data;
                });
            },
            jump(path) {
                this.$router.push({path: path})
            },
            handleSuifang() {
                this.$router.push({
                    path: "/rms/archives",
                    query: {data: "suifang"}
                })
            },
        }
    };
</script>
<style scoped>
    .el-row {
        margin: 5px 10px 20px 10px;
    }
    ::v-deep .el-col-5{
        width: 20% !important;
    }
    .tiaoz .el-col-6 {
        text-align: center;
        font-size: 14px;
        color: #606266
    }

    .tiaoz .el-button {
        margin-bottom: 8px;
        font-size: 17px;
        /*color: white;*/
        border: 1px solid #80b0d2;
        background: rgb(128, 176, 210);
    }

    .tiaoz .el-col-8 {
        text-align: center;
        font-size: 14px;
        color: #606266
    }

    .tiaoz .el-col-8 .el-button {
        margin-bottom: 8px;
        font-size: 14px;
        color: white;
        border: 1px solid #80b0d2;
        background: rgb(128, 176, 210);
    }

    .grid-content {
        display: flex;
        align-items: center;
        height: 130px;
    }

    .grid-content-shart {
        display: flex;
        align-items: center;
        height: 100px;
        background-color: #EBEEF5;
    }

    .grid-content-sharts {
        display: flex;
        align-items: center;
        height: 80px;
        background-color: #EBEEF5;
    }

    .grid-cont-right {
        flex: 1;
        text-align: center;
        font-size: 14px;
        color: #999;
    }

    .grid-num {
        font-size: 30px;
        font-weight: bold;
    }

    .grid-con-icon {
        font-size: 50px;
        width: 100px;
        height: 130px;
        text-align: center;
        line-height: 130px;
        color: #fff;
    }

    .grid-con-3 .grid-con-icon {
        background: rgb(195, 191, 226);
    }

    .grid-con-3 .grid-num {
        color: rgb(195, 191, 226);
    }

    .grid-con-1 .grid-con-icon {
        background: rgb(128, 176, 210);
    }

    .grid-con-1 .grid-num {
        color: rgb(128, 176, 210);
    }

    .grid-con-2 .grid-con-icon {
        background: rgb(141, 210, 198);
    }

    .grid-con-2 .grid-num {
        color: rgb(141, 210, 198);
    }

    .grid-con-4 .grid-con-icon {
        background: rgb(144, 147, 153);
    }

    .grid-con-4 .grid-num {
        color: rgb(144, 147, 153);
    }

    .grid-con-5 .grid-con-icon {
        background: rgb(250, 153, 141);
    }

    .grid-con-5 .grid-num {
        color: rgb(250, 153, 141);
    }

    .mgb20 {
        margin-bottom: 10px;
    }

    .el-col-5 {
        width: 20%;
    }

    .grid-num-shart {
        /*color: #333333;*/
        font-size: 16px !important;
        font-weight: bold;
        margin-top: 5px;
        color: #333333;
        /*line-height: 35px;*/
    }
    .but{
        color: white;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
</style>
